<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="toggleFrame">{{ $t('labels.frames.' + frame) }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="4">
        <template v-slot:thead>
          <tr>
            <bs-th scope="col">{{ $t('labels.name') }}</bs-th>
            <bs-th scope="col" class="text-right">{{ $tc('labels.budget', 1) }}</bs-th>
            <bs-th scope="col" class="text-left" :tip="'The average ' + frame + ' spend of each category based on ' + $t('labels.filters.' + resourceState.filters.last) + '.'" :label="$tc('labels.average_spent', 1)"></bs-th>
            <bs-th scope="col" class="text-right" :label="$tc('labels.spent', 1)" :tip="'Actual sum of transactions in each category for ' + $t('labels.filters.' + resourceState.filters.last) + '.'"></bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>{{ r.label }}</td>
          <td class="text-right">{{ $n(calcBudget(r), 'currency') }}</td>
          <td class="text-left" :class="calcSpend(r) > calcBudget(r) ? 'text-danger' : ''">{{ $n(calcSpend(r), 'currency') }}</td>
          <td class="text-right">{{ $n(r.spent, 'currency') }}</td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" :counts="[10, 15, 20, 50]" @pushPage="index" :filters="filters"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></input-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'
import { DateTime } from 'luxon'

export default {
  name: 'BudgetBalances',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'coins'],
      resource: {
        name: ''
      },
      frame: 'month',
      filters: {
        last: true
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.budgetBalances,
      resourceState: state => state.budgetBalancesState
    })
  },
  methods: {
    toggleFrame () {
      if (this.frame === 'week') this.frame = 'month'
      else if (this.frame === 'month') this.frame = 'annual'
      else this.frame = 'week'
    },
    calcBudget (r) {
      if (r.frame === this.frame) return r.amount
      let budget = 0
      if (r.frame === 'annual') budget = r.amount
      else if (r.frame === 'month') budget = r.amount * 12
      else if (r.frame === 'week') budget = r.amount * 52
      if (this.frame === 'annual') return budget
      else if (this.frame === 'month') return budget / 12
      else if (this.frame === 'week') return budget / 52
    },
    calcSpend (r) {
      let days = 0
      if (this.resourceState.filters.last === 'last_30') {
        days = 30
      } else if (this.resourceState.filters.last === 'last_60') {
        days = 60
      } else if (this.resourceState.filters.last === 'last_90') {
        days = 90
      } else if (this.resourceState.filters.last === 'last_120') {
        days = 120
      } else if (this.resourceState.filters.last === 'last_6') {
        const start = DateTime.now().startOf('month').minus({ months: 6 })
        const diff = DateTime.now().diff(start, 'days')
        days = parseInt(diff.days)
      } else if (this.resourceState.filters.last === 'last_9') {
        const start = DateTime.now().startOf('month').minus({ months: 9 })
        const diff = DateTime.now().diff(start, 'days')
        days = parseInt(diff.days)
      } else if (this.resourceState.filters.last === 'last_year') {
        const start = DateTime.now().startOf('month').minus({ year: 1 })
        const diff = DateTime.now().diff(start, 'days')
        days = parseInt(diff.days)
      }
      let dailySpend = parseInt(r.spent) / days
      if (dailySpend < 0) dailySpend = dailySpend * -1

      if (this.frame === 'annual') return dailySpend * 365
      else if (this.frame === 'month') return dailySpend * 30
      else if (this.frame === 'week') return dailySpend * 7
    }
  }
}
</script>
